<mat-grid-list [cols]="1">
  <huge-row>
    @if (title != null) {
      <p class="data-title">{{ title }}</p>
    } @if (status != null) {
    <mat-col class="ion-text-right data-title-status">
      <p>{{ status }}</p>
    </mat-col>
    }
  </huge-row>
</mat-grid-list>
